import React, { Component } from 'react';
import {
  Button,
  Card,
  Confirm,
  Form,
  Grid,
  Header,
  Icon,
  Image,
  Menu,
  Message,
  Modal,
  Segment,
} from 'semantic-ui-react';

import XHRAsset from '../xhr/asset.js';
import Utils from '../Utils.js';

let panel_themes = [
  {
    image: '/img/panels/basic.png',
    thumb: '/img/panels/basic.png',
    id: 'basic',
    label: 'Basic',
    subheader: '',
  },
  {
    image: '/img/panels/split.png',
    thumb: '/img/panels/split.png',
    id: 'split',
    label: 'Split',
    subheader: '',
  },
  {
    image: '/img/panels/woody.png',
    thumb: '/img/panels/woody.png',
    id: 'woody',
    label: 'Woody',
    subheader: '',
    new: true,
  },
  {
    image: '/img/panels/snow.png',
    thumb: '/img/panels/snow.png',
    id: 'snow',
    label: 'Snow',
    subheader: '',
  },
];

let banner_themes = [
  {
    image: '/img/banners/street.jpg',
    thumb: '/img/banners/street_thumb.jpg',
    id: 'street',
    label: 'Street',
    subheader: '',
  },
  {
    image: '/img/banners/split.jpg',
    thumb: '/img/banners/split_thumb.jpg',
    id: 'split',
    label: 'Split',
    subheader: '',
  },
  {
    image: '/img/banners/road.jpg',
    thumb: '/img/banners/road_thumb.jpg',
    id: 'road',
    label: 'Road',
    subheader: '',
  },
  {
    image: '/img/banners/fire.jpg',
    thumb: '/img/banners/fire_thumb.jpg',
    id: 'fire',
    label: 'Fire',
    subheader: '',
    new: true,
  },
  {
    image: '/img/banners/light.jpg',
    thumb: '/img/banners/light_thumb.jpg',
    id: 'light',
    label: 'Light',
    subheader: '',
    new: true,
  },
  {
    image: '/img/banners/iron.jpg',
    thumb: '/img/banners/iron_thumb.jpg',
    id: 'iron',
    label: 'Iron',
    subheader: '',
  },
  {
    image: '/img/banners/night_sky.jpg',
    thumb: '/img/banners/night_sky_thumb.jpg',
    id: 'night_sky',
    label: 'Night Sky',
    subheader: '',
  },
  {
    image: '/img/banners/dots.jpg',
    thumb: '/img/banners/dots_thumb.jpg',
    id: 'dots',
    label: 'Dots',
    subheader: '',
  },
  {
    image: '/img/banners/wall.jpg',
    thumb: '/img/banners/wall_thumb.jpg',
    id: 'wall',
    label: 'Wall',
    subheader: '',
  },
  {
    image: '/img/banners/forest.jpg',
    thumb: '/img/banners/forest_thumb.jpg',
    id: 'forest',
    label: 'Forest',
    subheader: '',
  },
  {
    image: '/img/banners/museum.jpg',
    thumb: '/img/banners/museum_thumb.jpg',
    id: 'museum',
    label: 'Museum',
    subheader: '',
  },
];

let overlay_lobby_themes = [
  {
    image: '/img/overlays/lobby_angle.jpg',
    thumb: '/img/overlays/lobby_angle_thumb.jpg',
    id: 'lobby_angle',
    label: 'Lobby Angle',
    subheader: '',
  },
  {
    image: '/img/overlays/lobby_woody.jpg',
    thumb: '/img/overlays/lobby_woody_thumb.jpg',
    id: 'lobby_woody',
    hot: true,
    label: 'Lobby Woody',
    subheader: '',
  },
  {
    image: '/img/overlays/lobby_subtle.jpg',
    thumb: '/img/overlays/lobby_subtle_thumb.jpg',
    id: 'lobby_subtle',
    label: 'Lobby Subtle',
    new: true,
    subheader: '',
  },
  {
    image: '/img/overlays/lobby_ruban.jpg',
    thumb: '/img/overlays/lobby_ruban_thumb.jpg',
    id: 'lobby_ruban',
    label: 'Lobby Ruban',
    subheader: '',
  },
];

let overlay_themes = [
  {
    image: '/img/overlays/neon.jpg',
    thumb: '/img/overlays/neon_thumb.jpg',
    id: 'neon',
    label: 'Neon',
    subheader: 'Elegant theme for an elegant stream.',
  },
  {
    image: '/img/overlays/angle.jpg',
    thumb: '/img/overlays/angle_thumb.jpg',
    id: 'angle',
    label: 'Angle',
    subheader: 'Lean design with angles',
    hot: true,
  },
  {
    image: '/img/overlays/woody.jpg',
    thumb: '/img/overlays/woody_thumb.jpg',
    id: 'woody',
    label: 'Woody',
    subheader: 'Energizing theme',
  },
  {
    image: '/img/overlays/subtle.jpg',
    thumb: '/img/overlays/subtle_thumb.jpg',
    id: 'subtle',
    label: 'Subtle',
    new: true,
    subheader: 'Subtle theme with transparency',
  },
  {
    image: '/img/overlays/basic.jpg',
    thumb: '/img/overlays/basic_thumb.jpg',
    id: 'basic',
    label: 'Basic',
    subheader: 'Simple but clean theme',
  },
  {
    image: '/img/overlays/ruban.jpg',
    thumb: '/img/overlays/ruban_thumb.jpg',
    id: 'ruban',
    label: 'Ruban',
    subheader: 'Footer username with ruban boxes',
  },
  {
    image: '/img/overlays/snow.jpg',
    thumb: '/img/overlays/snow_thumb.jpg',
    id: 'snow',
    label: 'Snow',
    subheader: 'White transparent',
  },
  {
    image: '/img/overlays/angle-cam-only.jpg',
    thumb: '/img/overlays/angle-cam-only_thumb.jpg',
    id: 'angle-cam-only',
    label: 'Angle — Cam only',
    subheader: 'Lean design with angles — Camera only',
  },
];

class ThemeSelection extends Component {
  constructor(props) {
    super(props);

    this.init();

    this.state = {
      theme: this.defaultTheme(),
      step: this.props.step,
      capacities: [],
      menuItem: 'ingame',
      theme_preview: { show: false, theme: null, },
      confirm_reset: { show: false, capacities: [], theme: null, },
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ step: nextProps.step, });
  }

  themes = () => {
    switch (this.props.assetType) {
      default:
      case 'overlay':
        if (this.state.menuItem === 'lobby') {
          return overlay_lobby_themes;
        } else {
          return overlay_themes;
        }
      case 'banner':
        return banner_themes;
      case 'panel':
        return panel_themes;
    }
  }

  defaultTheme = () => {
    switch (this.props.assetType) {
      default:
      case 'overlay':
        return 'angle';
      case 'banner':
        return 'dots';
      case 'panel':
        return 'basic';
    }
  }

  // init gets theme capabilities.
  // then select the default theme.
  init = () => {
    this.all_capacities = {};
    XHRAsset.capacities(this.props.assetType).then((json) => {
      this.all_capacities = json;
      this.changeTheme(this.defaultTheme(), true); // initialisation done, the default theme.
    });
  }

  render() {
    return (
      <Grid columns={1} stackable>
        <Grid.Column>
          <Segment>
            <Header as='h2' textAlign='left'>
              <Icon name='user outline' />
              <Header.Content>Theme selection</Header.Content>
              {this.props.assetType === 'overlay' &&
                <Header.Subheader>First, select a theme type and a theme.</Header.Subheader>
              }
              {this.props.assetType !== 'overlay' &&
                <Header.Subheader>First, select a theme.</Header.Subheader>
              }
            </Header>
          </Segment>
        </Grid.Column>
        <Grid.Column>

          {this.props.assetType === 'overlay' &&
          <Menu style={{marginBottom: '2em'}} compact icon='labeled'>
            <Menu.Item
              name='In-game overlays'
              active={this.state.menuItem === 'ingame'}
              onClick={() => { this.selectOverlayType('ingame'); }}
            ><Icon name='gamepad' />In-game overlays</Menu.Item>
            <Menu.Item
              name='Lobby overlays'
              active={this.state.menuItem === 'lobby'}
              onClick={() => { this.selectOverlayType('lobby'); }}
            ><Icon name='user' />Lobby overlays</Menu.Item>
          </Menu>}

          <Message
              info
              content={<span style={{fontSize: '1.2em'}}><Icon name="info circle" />Click on a theme to see a preview. The colors are fully configurable!</span>}
            />

          <Form.Field>
            <Card.Group itemsPerRow={2}>
            {this.themes().map((theme) => {
            return <Card key={theme.id} centered>
              {theme.image &&
                <a onClick={() => { this.openThemePreview(theme); }}>
                  {theme.new && <Image src={theme.image} label={{ as: 'span', ribbon: true, color: 'red', content: 'New!' }} />}
                  {theme.hot && <Image src={theme.image} label={{ as: 'span', ribbon: true, color: 'orange', content: 'Hot!' }} />}
                  {!theme.hot && !theme.new && <Image src={theme.image} />}
                </a>
              }
              <Card.Content>
                <Card.Header>{theme.label}</Card.Header>
                <Card.Description>{theme.subheader}</Card.Description>
              </Card.Content>
              <Card.Content extra>
                <Form.Radio onClick={() => { this.changeTheme(theme.id, false) }} checked={this.state.theme === theme.id}/>
              </Card.Content>
            </Card>
            })}
            <Modal dimmer='blurring' closeOnEscape={true} onClose={this.closeThemePreview} open={this.state.theme_preview.show} basic size='small'>
              <Header icon='image' content='Theme selection' />
              <Modal.Content>
                <p style={{fontSize: '1.2em'}}><Icon name="info circle" /> Please note that <strong>colors are configurable in the next steps</strong>.</p>
                {this.state.theme_preview.theme && <img src={this.themePreviewThumb()} style={{width: '100%'}} alt="Preview of the generated overlay" />}
              </Modal.Content>
              <Modal.Actions>
                <Button basic onClick={this.closeThemePreview} color='red' inverted>
                  Cancel
                </Button>
                <Button color='green' onClick={this.selectThemePreview}>
                  <Icon name='thumbs outline up' /> Select
                </Button>
              </Modal.Actions>
            </Modal>
            <Confirm
              open={this.state.confirm_reset.show}
              onCancel={() =>  {
                let m = this.state.confirm_reset;
                m.show = false;
                this.setState( {confirm_reset: m} );
              }}
              onConfirm={() => { this.confirmChangeTheme(); }}
              size='small'
              content="This theme doesn't ask the same information as the ones you've started to configure. Some configuration can be reseted and you might have to fill them again. Continue?"
            />
          </Card.Group>

        </Form.Field>
      </Grid.Column>
    </Grid>
    );
  }

  openThemePreview = (theme) => {
    let m = this.state.theme_preview;
    m.show = true;
    m.theme = theme;
    this.setState({
      theme_preview: m,
    });
  }

  closeThemePreview = () => {
    let m = this.state.theme_preview;
    m.show = false;
    this.setState({
      theme_preview: m,
    });
  }

  selectOverlayType = (type) => {
    this.setState({
      menuItem: type,
    });
  }

  selectThemePreview = () => {
    let m = this.state.theme_preview;
    m.show = false;
    this.changeTheme(m.theme.id, false);
    this.setState({
      theme_preview: m,
    });
  }

  // changeTheme gets the capacities of the next theme:
  // if they're not the same, they ask the user if he's ready to
  // lose his previously filled fields (if the init flag is off).
  changeTheme = (new_theme, init) => {
    let new_capacities = this.all_capacities[new_theme];
    // TODO(remy): restore the test on the step?
    if (!init && !Utils.sameCapacities(this.state.capacities, new_capacities) && this.state.step > 1) {
      // we need to confirm that we'll change the theme.
      let m = this.state.confirm_reset;
      m.show = true;
      m.theme = new_theme;
      m.capacities = new_capacities;
      this.setState({
        confirm_reset: m,
      });
    } else {
      // directly sets the new theme because we don't have
      // to confirm the change.
      this.setState({
        theme: new_theme,
        capacities: new_capacities,
      });
      this.props.onChangeTheme(new_theme, new_capacities, !init);
    }
  }

  confirmChangeTheme = () => {
    let m = this.state.confirm_reset;
    m.show = false;
    this.setState({
      confirm_reset: m,
      theme: m.theme,
      capacities: m.capacities,
    });
    this.props.onChangeTheme(m.theme, m.capacities, true);
  }

  themePreviewThumb = () => {
    if (!this.state.theme_preview.theme) {
      return '';
    }
    return this.state.theme_preview.theme.image;
  }
}

export default ThemeSelection;



// WEBPACK FOOTER //
// ./src/tool/ThemeSelection.js